import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import PDFViewer from '../PDFViewer';

const TermsModal = (props) => {
    const {show,setShow} = props;
  return (
    <>
      <Modal show={show} onHide={()=>{setShow(false)}} size="xl" scrollable>
        <Modal.Header closeButton className='border-bottom-0'>
          <Modal.Title className='h5'>PwC - Terms of Use</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '75vh', overflowY: 'auto' }}>
          <PDFViewer fileUrl="/Legal_Terms_of_Use.pdf" />
        </Modal.Body>
        <Modal.Footer className='border-top-0'>
          <Button variant="primary" onClick={()=>{setShow(false)}}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default TermsModal;
